"use client"

import { FilePlusCorner } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FilePlusCornerIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FilePlusCornerIcon = component(Icon)({ as: FilePlusCorner })
